import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { TherapistAction } from 'src/redux/actions/constant';
import therapistService from 'src/services/apiServices/therapist-scheduling/therapistService';

const {
  THERAPIST_DEFAULT_THERAPIST_SUCCESS,
  THERAPIST_DEFUALT_THERAPIST_REQUEST,
  THERAPIST_DEFAULT_THERAPIST_FAILURE,
} = TherapistAction;

function*  defaultTherapistsAssign(action: any): SagaReturnType<any> {
  try {
    const response = yield call(therapistService.defaultTherapistAssignSerivce, action.payload);
    if (response?.status === 200) {
      yield put({
        type: THERAPIST_DEFAULT_THERAPIST_SUCCESS,
        payload: response.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: THERAPIST_DEFAULT_THERAPIST_FAILURE, payload: error });
  }
}

function* defaultTherapistAssignSaga() {
  yield takeEvery(THERAPIST_DEFUALT_THERAPIST_REQUEST, defaultTherapistsAssign);
}

export default defaultTherapistAssignSaga;
